/**
 * React Query Provider component for the doctor platform
 * 
 * This component provides React Query functionality with proper error boundaries,
 * dev tools integration, and optimized configuration for medical applications.
 */

import React, { type ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './config';

interface ReactQueryProviderProps {
  children: ReactNode;
}

/**
 * React Query Provider with dev tools and error handling
 */
export function ReactQueryProvider({ children }: ReactQueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Only show dev tools in development */}
      {import.meta.env.DEV && (
        <ReactQueryDevtools
          initialIsOpen={false}
          position="bottom-right"
          buttonPosition="bottom-right"
          panelPosition="bottom"
          toggleButtonProps={{
            style: {
              marginLeft: '5px',
              transform: undefined,
              zIndex: 9999,
            },
          }}
        />
      )}
    </QueryClientProvider>
  );
}

export default ReactQueryProvider;